export const ar = {
  newRequest: 'طلب جديد',
  userRequestsList: 'الطلبات التي أنشأتها',
  defendantRequestsList: 'الطلبات المقدمة ضدي',
  noSearchResultsFound: 'لا يوجد نتائج تطابق البيانات المدخلة',
  noRequestsFound: 'لايوجد لديك طلبات',
  noSearchResultsFoundDescription: 'الرجاء التأكد من البيانات، والمحاولة مجدداً.',
  noRequestsFoundDescription: 'يمكنك إنشاء طلب جديد',
  search: 'بحث ...',
  requestType: 'نوع الطلب',
  requestStatus: 'حالة الطلب',
  sortBy: 'ترتيب حسب',
  timePeriod: 'الفترة الزمنية',
  theNewest: 'الأحدث',
  theOldest: 'الأقدم',
  requestNumber: 'رقم الطلب',
  applicant: 'مقدم الطلب',
  applicantType: 'صفة مقدم الطلب',
  requestCategory: 'نوع الطلب',
  meladiSuffix: 'م',
  actions: 'الإجراءات',
  requestDate: 'تاريخ الطلب',
  chooseTheAction: 'اختر الإجراء',
  financialClaim: 'مطالبة مالية',
  contractNotification: 'إخطار تعاقدي',
  actionsMenuLabel: 'اختر الإجراء',
  editRequestDetails: 'تعديل بيانات الطلب',
  downloadBill: 'تحميل الفاتورة',
  downloadCertificate: 'تحميل الإخطار',
  deleteRequest: 'حذف الطلب',
  cancelRequest: 'إلغاء الطلب',
  payment: 'الدفع',
  deleteRequestConfirmation: 'هل أنت متأكد من حذف طلب',
  cancelRequestConfirmation: 'هل أنت متأكد من إلغاء الطلب',
  deleteRequestSuccessMessage: 'تم حذف طلب رقم {requestCode} بنجاح',
  cancelRequestSuccessMessage: 'تم إلغاء طلب رقم {requestCode} بنجاح',
  dateOfReceipt: 'تاريخ الإستلام',
  applicantTypes: {
    bySelf: 'بالأصالة عن نفسه',
    byCompany: 'بالنيابة عن منشأة',
    byTawkeel: 'وكالة عن الغير',
  },
  jtpVerificationServiceText: 'يمكنك الاستعلام عن الطلب في حال عدم ظهوره ضمن قائمة الطلبات من خلال',
  jtpVerificationService: 'خدمة التحقق عن تبليغ عدلي',
  noDefendantRequestsFound: 'لايوجد طلبات مقدمة ضدك',
  financialClaimRequestDescription: 'خدمة تتيح للمستفيد إخطار أحد طرفي العلاقة التعاقدية بطلب الوفاء بالتزاماته التعاقدية، طبقاً لمتطلبات نظام المحاكم التجارية.',
  financialClaimRequest: 'طلب مطالبة مالية',
  applicantInfo: 'مقدم الطلب',
  partyTobeNotifiedData: 'بيانات الطرف المراد إخطاره',
  requestData: ' بيانات الطلب',
  requestPreview: 'معاينة الطلب',
  individual: 'فرد',
  organization: 'منشأة',
  idNumber: 'رقم الهوية',
  phoneNumber: 'رقم الجوال',
  email: 'البريد الإلكتروني',
  crNumber: 'رقم المنشأة الوطني',
  crNumberHelperText: 'رقم المنشأة الوطني  المراد إخطارها',
  iqamaOrNationalId: 'رقم الهوية / الاقامة',
  iqamaOrNationalIdHelperText: 'رقم هوية الطرف المراد إخطاره',
  chooseTheAdjective: 'اختر الصفة',
  notificationType: 'وسيلة الإخطار',
  chooseNotificationType: 'اختر وسيلة الإخطار',
  hintMobileAbsher: 'رقم جوال بديل للطرف المراد إخطاره في حالة عدم توفر رقم جوال مرتبط بالهوية',
  hintMobileCR: 'رقم جوال بديل للمنشأة المراد إخطارها في حالة عدم توفر رقم جوال مرتبط برقم المنشأة الوطني',
  hintMobile: 'رقم جوال المستلم للإشعارات العدلية',
  absherEmailHint: 'البريد الإلكتروني للطرف المراد إخطاره',
  CrEmailHint: 'البريد الإلكتروني للمنشأة المراد إخطارها',
  emailPlaceholder: 'مثال: example@mail.com',
  fulfillmentAmountLabel: 'قيمة أداء الحق رقميًا',
  fulfillmentAmountPlacehoder: 'مثال: 1530',
  translatedFulfillmentAmountLabel: 'قيمة أداء الحق كتابة',
  translatedFulfillmentAmountPlacehoder: 'مثال: ألف وخمسمائة وثلاثون ريال سعودي فقط لاغير',
  financialClaimRequestDetails: 'تفاصيل طلب مطالبة مالية',
  financialClaimRequestDetailsPlaceholder: 'أدخل تفاصيل طلب مطالبة مالية',
  financialClaimRequestDetailsHint: 'يجب أن يحتوى الوصف على موضوع النزاع والطلبات ',
  claimDocuments: 'مستندات المطالبة',
  claimDate: 'تاريخ المطالبة ',
  claimDatePlaceholder: 'أدخل تاريخ المطالبة المالية',
  claimDateHint: 'يمكنك اختيار تاريخ المطالبة من بعد {numOfDays} يوم من تقديم الطلب للتقدم إلى المحكمة',
  claimDocumentsHint: 'نوع الملف يجب أن يكون ({extentions}) كحد أقصى {maxFileSizeInMega} م.ب',
  institutionName: 'اسم المنشأة',
  applicantName: 'اسم مقدم الطلب',
  applicantInformations: 'معلومات مقدم الطلب',
  byAttorneyNotice: 'إخطار بالوكالة عن الغير',
  onBehalfNotice: 'إخطار بالأصالة عن النفس',
  attorneyData: 'بيانات الوكالة',
  attorneyNumber: 'رقم الوكالة',
  attorneyNumberPlaceholder: 'أدخل رقم الوكالة',
  delegatedCRorNID: 'رقم هوية الموكل',
  delegatedCRorNIDPlaceholder: 'أدخل رقم هوية الموكل',
  verify: 'تحقق',
  agentName: 'اسم الموكل',
  agentId: 'هوية الموكل',
  backToVerify: 'العودة للتحقق',
  pleaseVerifyAttorneyData: 'الرجاء التحقق من بيانات الوكالة',
  confirmAndPayment: 'التأكيد و الدفع',
  noticeText: 'نص الإخطار',
  defendantWillRecieveTheFollowing: 'سيتم تسليم المراد اخطاره ما يلي',
  paymentInfo: 'بيانات الدفع',
  amount: 'السعر (قبل الضريبة)',
  vat: 'الضريبة',
  totalAmount: 'المبلغ الإجمالي',
  consentText: 'أقر بأني قرأت ',
  termsAndConditions: 'الشروط والأحكام',
  retreat: 'تراجع',
  backText: 'رجوع',
  approveConcent: 'قبول وموافقة',
  saveAndCompleteLater: 'حفظ وإكمال لاحقًا',
  savingAsDraftProgress: 'جاري الحفظ ...',
  cancel: 'إلغاء',
  requestsList: 'قائمة الطلبات',
  saveAsDraftSuccessMessage: 'تم حفظ الطلب كمسودة',
  saveAsDraftDescription: 'يمكنك إكمال الطلب لاحقًا من خلال قائمة الطالبات',
  financialClaimNo: 'مطالبة مالية {claimNumber}',
  copiedSuccessfully: 'تم النسخ بنجاح',
  jtpVerification: 'التحقق من تبليغ عدلي',
  jtpVerificationDescription: 'خدمة إلكترونية تتيح التحقق من الإخطارات الواردة',
  notificationMethodType: 'نوع وسيلة الإخطار',
  notificationMethodTypeHint: 'تمثل وسيلة الاخطار طريقة  إستلام رسالة  المطالبة المالية',
  backToVerificationServices: 'العودة لخدمات التحقق',
  backToRequestsList: 'عودة إلى قائمة الطلبات',
  newVerification: 'تحقق جديد',
  meladiShortcut: 'م',
  otherRequestInquiryBtn: 'الاستعلام',
  addDelegatorDetails: 'تفاصيل إضافة مستلم للإشعارات العدلية',
  addDelegatorSuccessMessage: 'تم إضافتك كمستلم للإشعارات العدلية',
  delegatorInfo: 'البيانات الشخصية للمستلم',
  delegatorPrivilidages: 'صلاحيات نوع الإشعارات',
  profileValidation: {
    message: 'لايمكنك استخدام خدمات التبليغ العدلي؛ لعدم اكتمال معلومات ممثل الحساب  قم بإكماله الآن من خلال',
    accountManagement: 'إدارة الحساب',
  },

  requestStatuses: {
    draft: 'مسودة',
    waitingForPayment: 'بإنتظار السداد',
    completed: 'مرسل',
    deleted: 'محذوف',
    schedule: 'مجدول',
  },

  validations: {
    fieldIsRequired: 'هذا الحقل مطلوب',
    dateAfterDays: 'يجب أن يكون تاريخ المطالبة بعد {days} يوم الموافق {equivalent}',
  },
};
